import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "pv-rel-text" }
const _hoisted_3 = ["href", "title"]
const _hoisted_4 = { class: "pv-rel-text" }
const _hoisted_5 = { key: 4 }
const _hoisted_6 = ["title"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = ["disabled", "title"]
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = {
  key: 2,
  class: "pv-image-zoom"
}
const _hoisted_11 = ["title"]
const _hoisted_12 = ["href", "title"]
const _hoisted_13 = { key: 14 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_color_accent = _resolveComponent("ontos-color-accent")!
  const _component_ontos_colored_option = _resolveComponent("ontos-colored-option")!
  const _component_ontos_person_line = _resolveComponent("ontos-person-line")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_ontos_audio_player = _resolveComponent("ontos-audio-player")!
  const _component_ontos_markdown_excerpt = _resolveComponent("ontos-markdown-excerpt")!
  const _component_ontos_markdown_expandable = _resolveComponent("ontos-markdown-expandable")!

  return (_ctx.kind === 'rel' && _ctx.variant === 'card')
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "pv-rel",
        title: _ctx.text
      }, [
        (_ctx.accent)
          ? (_openBlock(), _createBlock(_component_ontos_color_accent, {
              key: 0,
              vertical: "",
              color: _ctx.relColor,
              class: "pv-rel-accent"
            }, null, 8, ["color"]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.text), 1)
      ], 8, _hoisted_1))
    : (_ctx.kind === 'rel')
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          class: "pv-rel pv-rel-link",
          href: _ctx.relHref,
          title: _ctx.text,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('link', {event: $event, context: _ctx.relContext})))
        }, [
          (_ctx.accent)
            ? (_openBlock(), _createBlock(_component_ontos_color_accent, {
                key: 0,
                vertical: "",
                color: _ctx.relColor,
                class: "pv-rel-accent"
              }, null, 8, ["color"]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.text), 1)
        ], 8, _hoisted_3))
      : (_ctx.kind === 'choice' && _ctx.option)
        ? (_openBlock(), _createBlock(_component_ontos_colored_option, {
            key: 2,
            option: _ctx.option
          }, null, 8, ["option"]))
        : (_ctx.kind === 'user' && _ctx.person)
          ? (_openBlock(), _createBlock(_component_ontos_person_line, {
              key: 3,
              class: _normalizeClass(["pv-person", {'pv-person--unassignable': !_ctx.person.assignable}]),
              title: _ctx.person.assignable ? undefined : _ctx.$tt('person-unassignable'),
              user: _ctx.person.user,
              name: _ctx.person.name,
              photo: _ctx.person.photo,
              dense: _ctx.variant !== 'detail'
            }, null, 8, ["class", "title", "user", "name", "photo", "dense"]))
          : (_ctx.kind === 'date')
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.text), 1))
            : (_ctx.kind === 'boolean')
              ? (_openBlock(), _createElementBlock("span", {
                  key: 5,
                  class: _normalizeClass(["pv-boolean", `text-${_ctx.face.color}`])
                }, [
                  _createVNode(_component_v_icon, {
                    size: "small",
                    color: _ctx.face.color
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.face.icon), 1)
                    ]),
                    _: 1
                  }, 8, ["color"]),
                  _createTextVNode(_toDisplayString(_ctx.face.label), 1)
                ], 2))
              : (_ctx.kind === 'image' && _ctx.variant === 'card' && _ctx.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 6,
                    class: "pv-image pv-card",
                    title: _ctx.failed ? _ctx.$tt('image.missing') : _ctx.property.name
                  }, [
                    (!_ctx.failed)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.value,
                          alt: _ctx.property.name,
                          loading: "lazy",
                          decoding: "async",
                          onError: _cache[1] || (_cache[1] = ($event: any) => (_ctx.failed = true))
                        }, null, 40, _hoisted_7))
                      : (_openBlock(), _createBlock(_component_v_icon, {
                          key: 1,
                          color: "grey",
                          size: "small"
                        }, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode("mdi-image-broken-variant", -1)
                          ]))]),
                          _: 1
                        }))
                  ], 8, _hoisted_6))
                : (_ctx.kind === 'image' && _ctx.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 7,
                      type: "button",
                      class: _normalizeClass(["pv-image", _ctx.variantClass]),
                      disabled: _ctx.failed,
                      title: _ctx.failed ? _ctx.$tt('image.missing') : _ctx.property.name,
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('preview', {src: _ctx.value, title: _ctx.property.name})), ["stop"]))
                    }, [
                      (!_ctx.failed)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.value,
                            alt: _ctx.property.name,
                            loading: "lazy",
                            decoding: "async",
                            onError: _cache[2] || (_cache[2] = ($event: any) => (_ctx.failed = true))
                          }, null, 40, _hoisted_9))
                        : (_openBlock(), _createBlock(_component_v_icon, {
                            key: 1,
                            color: "grey",
                            size: _ctx.variant === 'cell' ? 'small' : undefined
                          }, {
                            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                              _createTextVNode("mdi-image-broken-variant", -1)
                            ]))]),
                            _: 1
                          }, 8, ["size"])),
                      (!_ctx.failed)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                            _createVNode(_component_v_icon, {
                              size: "small",
                              color: "white"
                            }, {
                              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                _createTextVNode("mdi-magnify-plus-outline", -1)
                              ]))]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_8))
                  : (_ctx.kind === 'audio' && _ctx.variant === 'card' && _ctx.value)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 8,
                        class: "pv-audio-mark",
                        title: _ctx.property.name
                      }, [
                        _createVNode(_component_v_icon, {
                          size: "x-small",
                          color: "grey-darken-1"
                        }, {
                          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                            _createTextVNode("mdi-music-note", -1)
                          ]))]),
                          _: 1
                        })
                      ], 8, _hoisted_11))
                    : (_ctx.kind === 'audio' && _ctx.value)
                      ? (_openBlock(), _createBlock(_component_ontos_audio_player, {
                          key: 9,
                          src: _ctx.value,
                          label: _ctx.property.name,
                          compact: _ctx.variant === 'cell'
                        }, null, 8, ["src", "label", "compact"]))
                      : (_ctx.kind === 'markdown' && _ctx.variant === 'card')
                        ? (_openBlock(), _createBlock(_component_ontos_markdown_excerpt, {
                            key: 10,
                            value: _ctx.markdown
                          }, null, 8, ["value"]))
                        : (_ctx.kind === 'markdown' && _ctx.variant === 'detail' && _ctx.isSingleLineMarkdown(_ctx.markdown))
                          ? (_openBlock(), _createBlock(_component_ontos_markdown_excerpt, {
                              key: 11,
                              value: _ctx.markdown,
                              full: ""
                            }, null, 8, ["value"]))
                          : (_ctx.kind === 'markdown')
                            ? (_openBlock(), _createBlock(_component_ontos_markdown_expandable, {
                                key: 12,
                                value: _ctx.markdown,
                                class: "pv-markdown-cell"
                              }, null, 8, ["value"]))
                            : (_ctx.kind === 'url' && _ctx.href)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 13,
                                  href: _ctx.href,
                                  title: _ctx.text,
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                  class: _normalizeClass(["url-value no-drag", {'url-value--cell': _ctx.variant === 'cell'}]),
                                  onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                                }, _toDisplayString(_ctx.text), 11, _hoisted_12))
                              : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.text), 1))
}